import SubscriptionService from '../../shared/subscription/subscriptionService';
import {ISubscriptionProduct} from '../../shared/subscription/types';

export const rechargeSubService: SubscriptionService = {
  addSubProductsToCart(subProducts: ISubscriptionProduct[]): void {
    window['blubolt'].cart.addToCart(
      subProducts,
      false
    );
  },
};